import styles from './linkTab.module.css';
import { LinkTabProps } from './types';
import { Tab } from '@mui/material';
import React from 'react';

const LinkTab = (props: LinkTabProps) => {
  const { handleNavigation, tabIcon, href, ...rest } = props;

  return (
    <Tab
      className={styles.unselectedTab}
      component="a"
      icon={tabIcon}
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        handleNavigation(href);
      }}
      {...rest}
    ></Tab>
  );
};

export default LinkTab;
